export default "__VITE_ASSET__CdMEgQfn__"